/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SIM_PAGINATOR_INTL_PROVIDER as ɵc,SIM_PAGINATOR_INTL_PROVIDER_FACTORY as ɵb,SimPaginatorIntl as ɵa} from './paginator-intl';